import AssignAgentModal from './styled';

export default AssignAgentModal;
